import { resetPasswordMutation } from 'graphql/mutations';
import useAuth from './useAuth';

const useResetPassword = () => {
  const [resetPassword] = useAuth(resetPasswordMutation);
  return resetPassword;
};

export default useResetPassword;
